import {Parent} from './parent'
class ContractTypeClass extends Parent {
    constructor(...arg) {
        super(...arg)
    }
    getSubType(key) {
        if (!this) {
            return null
        }
        return (this[key] || {}).sub_type || '-'
    }
}

ContractTypeClass.f_name = 'ContractTypeClass'

export default ContractTypeClass